<div class="login-modal login-component">
  <div class="modal-header">
    <h2 class="modal-title">{{ 'account.login.signin.heading' | translate }}</h2>
    <button
      type="button"
      class="close"
      [title]="'dialog.close.text' | translate"
      [attr.aria-label]="'dialog.close.text' | translate"
      (click)="hide()"
      ngbAutofocus
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <div data-testing-id="account-login-page">
      @if (loginMessageKey) {
      <p class="alert alert-info">
        <!-- keep-localization-pattern: ^account\.login\..*\.message$ -->
        {{ 'account.login.' + loginMessageKey + '.message' | translate }}
      </p>
      }

      <ish-identity-provider-login
        class="login-felid-container"
        labelClass="col-12"
        inputClass="col-12"
        signInClass="col-12 btn-group pb-3"
        forgotPasswordClass="col-12 pb-3 text-center"
      />

      <div class="row auth0-btn-wrapp">
        <div class="col-12 mb-3">
          <ish-auth0-sign-in [isModal]="true"></ish-auth0-sign-in>
        </div>

        <div class="col-12 mb-3">
          <ish-azure-sign-in [isModal]="true"></ish-azure-sign-in>
        </div>
      </div>

      <p
        class="text-center"
        [ishServerHtml]="'account.login.register_now' | translate : { '0': 'route://register?returnUrl=/account' }"
      ></p>
    </div>
  </div>
</div>
